// Legacy code, just modularized

import $ from 'jquery';
import cookie from './cookie';


const naviPopupNotice = {
  init: function() {
    if($('#navi-popup-notice').length ) {

      if(!cookie.read('palmia_notice_popup')) {

        $(window).on('scroll', function() {
          var s = $(window).scrollTop();

          if(s > 0 && s < 115 )
            $('#navi-popup-notice .navi-popup-holder').css('top', ( s * -3 + 100) + '%');
          else if(s <= 0 )
            $('#navi-popup-notice .navi-popup-holder').css('top', '100%');
          else
            $('#navi-popup-notice .navi-popup-holder').css('top', '-500%');
        });


        $('#navi-popup-notice').removeClass('hide');

        setTimeout(function() {
          $('#navi-popup-notice .navi-popup-holder').css('top', '100%');
        }, 500);

        $('#popup-checkbox').on('change', function() {
          if(this.checked) {
            setTimeout(function() {
              cookie.create('palmia_notice_popup', '1', 100);
              $('#navi-popup-notice').fadeOut(200);
              setTimeout(function() {
                $('#navi-popup-notice').addClass('hide');
              }, 250);
            }, 500);
          }
        });

        $('#navi-popup-notice div a').on('click', function(e) {
          e.preventDefault();

          $('#navi-popup-notice').fadeOut(200);
          setTimeout(function() {
            $('#navi-popup-notice').addClass('hide');
          }, 250);
        });

      }
    }
  }
}

export default naviPopupNotice;


